import useTrans from '../../../hooks/useTrans'
import { priceNotation } from '../../../utils/safe'
import { Tooltip } from '../../atoms'
import { Info } from '../../atoms/NewIcons'
import { DettagliProdottoData } from '../DettagliProdotto/DettagliProdotto'

const allListiniIdentici = (tecnica) => {
  const posizioni = tecnica?.posizioni || []

  // Se una sola posizione (con uno o più numero_colori) nascondo colonna
  if (posizioni.length <= 1) return true

  // Mappa: num_colori_id (o nome) → Set dei listini trovati in posizioni diverse
  const mapColorToListini = new Map()

  for (const pos of posizioni) {
    for (const nc of pos?.numero_colori || []) {
      const colorKey = nc?.id || nc?.nome
      for (const pers of nc?.personalizzazioni_objects || []) {
        const listino = pers?.listino_codice
        if (!listino) return false

        if (!mapColorToListini.has(colorKey)) {
          mapColorToListini.set(colorKey, new Set())
        }
        mapColorToListini.get(colorKey).add(listino)
      }
    }
  }

  // Se ogni "numero_colori" ha un solo listino usato tra tutte le posizioni → listini identici
  for (const set of mapColorToListini.values()) {
    if (set.size > 1) {
      return false
    }
  }

  return true
}

const DettagliProdottoListino = ({ prezzi, colorsByTecnica }) => {
  const t = useTrans()

  return (
    <div className="dettagli-prodotto__listino">
      {prezzi?.tecniche?.map((tecnica, i) => {
        const flatten = allListiniIdentici(tecnica)
        const firstPos = tecnica?.posizioni?.[0]
        const headerQuantita =
          firstPos?.numero_colori?.[0]?.personalizzazioni_objects?.[0]?.prezzi_personalizzazione ||
          []
        const coloriTecnica = colorsByTecnica[tecnica.id]
        const colorsLabel = coloriTecnica?.length > 0 ? `(${t("solo per colori")} ${coloriTecnica.map(({nome}) => nome).join(", ")})` : ""
        return (
          <div className="dettagli-prodotto__listino__block" key={i}>
            {/* Titolo tecnica */}
            <div className="dettagli-prodotto__listino__header">
              <h3
                className={`dettagli-prodotto__listino__title ${
                  i == 0 ? 'dettagli-prodotto__listino__title__first' : ''
                } `}
              >
                {tecnica?.nome} {colorsLabel}
                <span className="consegna-prevista__info">
                  <Tooltip
                    label={t(
                      'Il prezzo è calcolato in base alla lavorazione consigliata. Non include i costi di avviamento e gestione'
                    )}
                  >
                    <Info />
                  </Tooltip>
                </span>
              </h3>
            </div>

            {/* Tabella */}
            <div className="dettagli-prodotto__listino__wrapper">
              <table className="dettagli-prodotto__listino__table">
                <thead>
                  <tr className="dettagli-prodotto__listino__table__head__row">
                    {!flatten && (
                      <th className="dettagli-prodotto__listino__table__head">{t('Posizione')}</th>
                    )}
                    <th className="dettagli-prodotto__listino__table__head">{t('Num. colori')}</th>
                    {headerQuantita.map((p, idx) => (
                      <th key={idx}>{`${p.a_partire_da}+`}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {flatten
                    ? (firstPos?.numero_colori || []).map((nc) =>
                        (nc?.personalizzazioni_objects || []).map((pers) => (
                          <tr key={`onlyfirst-${nc.id}-${pers.id}`}>
                            <td className="dettagli-prodotto__listino__table__colore">
                              {nc?.nome}
                            </td>
                            {pers?.prezzi_personalizzazione?.map((obj, idx) => (
                              <td key={idx} className="dettagli-prodotto__listino__table__value">
                                {priceNotation(obj.prezzo, 3)} €
                              </td>
                            ))}
                          </tr>
                        ))
                      )
                    : tecnica.posizioni?.map((posizione) =>
                        posizione.numero_colori?.map((nc) =>
                          nc.personalizzazioni_objects?.map((pers) => (
                            <tr key={`${posizione.id}-${nc.id}-${pers.id}`}>
                              <td className="dettagli-prodotto__listino__table__pos">
                                {posizione.nome} ({pers.dimensione_larghezza}x
                                {pers.dimensione_altezza})
                              </td>
                              <td className="dettagli-prodotto__listino__table__colore">
                                {nc.nome}
                              </td>
                              {pers.prezzi_personalizzazione?.map((obj, idx) => (
                                <td key={idx} className="dettagli-prodotto__listino__table__value">
                                  {priceNotation(obj.prezzo, 3)} €
                                </td>
                              ))}
                            </tr>
                          ))
                        )
                      )}
                  {/* Costo impianto */}
                  <tr className="dettagli-prodotto__listino__impianto">
                    <td className="dettagli-prodotto__listino__table__pos">{t('Impianto')}</td>
                    <td className="dettagli-prodotto__listino__table__colore" colSpan="3">
                      {!!tecnica.costo_impianto ? (
                        <>
                          {priceNotation(tecnica.costo_impianto, 2)} €
                          {!tecnica.posizioni?.[0]?.numero_colori?.[0]?.full_color
                            ? ` ${t('per colore')}`
                            : ''}
                        </>
                      ) : (
                        t('Gratuito')
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default DettagliProdottoListino
